<template>

    <v-container fluid fill-height>
        <v-layout>
            <v-flex>
                <v-card class="fix-card" style="margin-top: 0;">
                    <h1 class="mb-3">Početna</h1>

                    <h5>Mesečni prihodi: {{ formatNumber(plus) }} RSD </h5>

                    <h5>Mesečni rashodi: {{ formatNumber(minus) }} RSD</h5>

                    <h5>Mesečni bilans: {{ formatNumber(plus - minus) }} RSD</h5>

                    <h5>Ukupan bilans: {{ formatNumber(bilans) }} RSD</h5>

                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    export default{
        data(){
            return {
                  plus: 0,
                  minus: 0,
                  bilans: 0,
            }
        },
        mounted(){
            this.getBilans()
        },
        methods: {
            getBilans(){
              axios.get('home')
                .then(res => {
                  this.plus = res.data.plus;
                  this.minus = res.data.minus;
                  this.bilans = res.data.bilans;
                })
                .catch(e => {
                  console.log(e);
                  this.error = e.response.data.errors;
                });
            },
           formatNumber (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
            },
        }
    }
</script>
